<div class="flex-row full column align-start position-relative p-24">
    <button type="button" class="btn p-0 color-secondary close-modal" (click)="closeDialog()"
        aria-label="Close">X</button>
    <div class="flex-row full column align-start row-gap-16">
        <h2 class="fs-22 fw-7 color-secondary">Reminder Setting</h2>
        <form class="flex-row full column align-start row-gap-16" autocomplete="off" [formGroup]="sipForm"
            (ngSubmit)="onSubmitForm()">
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">Day</label>
                <div class="flex-row full position-relative">
                    <input type="text" readonly
                        class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4" placeholder="Day"
                        formControlName="sipDate" [matMenuTriggerFor]="sipDateMenu" #dateMenu="matMenuTrigger">
                    <button type="button" class="btn p-0 btn-abs" (click)="dateMenu.openMenu()"
                        aria-label="Open Calander">
                        <i class="icon icon-calander "></i>
                    </button>
                </div>
                <mat-menu #sipDateMenu="matMenu" class="sip-date-model-panel">
                    <div tabindex="0" role="button"
                        class="flex-row column full align-center row-gap-15 pl-20 pr-20 pt-10 pb-10"
                        (click)="$event.stopPropagation()" (keydown.enter)="$any($event.currentTarget).click()"
                        (keydown.space)="$event.preventDefault(); $any($event.currentTarget).click()">
                        <div class="fs-20 color-secondary">Reminder Date</div>
                        <p class="fs-16 color-primary" *ngIf="selectedDay">
                            {{ selectedDay }}
                            {{
                            selectedDay == "1" || selectedDay == "21"
                            ? "st"
                            : selectedDay == "2" || selectedDay == "22"
                            ? "nd"
                            : selectedDay == "3" || selectedDay == "23"
                            ? "rd"
                            : "th"
                            }}
                            of every month
                        </p>
                        <div class="flex-row full flex-wrap row-gap-10 column-gap-10">
                            <button type="button"
                                class="btn p-0 flex-row align-center content-center color-secondary width-4 height-4"
                                [ngClass]="{'bg-primary-light':day==selectedDay}" *ngFor="let day of days"
                                (click)="onSelectDay(day)">
                                {{ day }}
                            </button>
                        </div>
                        <button type="button" class="btn btn-primary" (click)="confirmDay()" [disabled]="!selectedDay">
                            Confirm
                        </button>
                    </div>
                </mat-menu>
            </div>
            <div class="flex-row full column align-start">
                <label class="fs-14 color-secondary mb-2">Amount</label>
                <input type="number" class="border-1 color-primary width-100-pr m-0 p-11 fs-16 border-radius-4"
                    placeholder="Amount" formControlName="sipAmount">
                <span class="text-danger fs-14"
                    *ngIf="sipForm.controls['sipAmount'].touched&&sipForm.controls['sipAmount'].errors?.required">
                    Amount is required.
                </span>
            </div>
            <button type="submit" class="btn btn-primary btn-large width-100-pr" [disabled]="sipForm.invalid">
                {{ data.sipAmount && data.sipDate ? "Update Reminder" : "Start Reminder" }}
            </button>
        </form>
    </div>
</div>